import styled from "styled-components";

export const SideMenuCrossBrandsListBox = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
  margin: 1rem 0;
  padding: 0;
  list-style-type: none;
`